import type { ApiClient } from './client';
import type { HostPolicy } from '@relay/shared';

export interface HostSummary {
  id: string;
  name: string;
  ownerId: string;
  online: boolean;
  lastSeenAt: number | null;
  policy: HostPolicy;
  createdAt: number;
}

export interface ListHostsResponse {
  hosts: HostSummary[];
}

export function listHosts(api: ApiClient): Promise<ListHostsResponse> {
  return api.request<ListHostsResponse>('GET', '/api/hosts');
}

export interface CreatedHost {
  id: string;
  name: string;
  hostToken: string;
  policy: HostPolicy;
  createdAt: number;
}

export function createHost(api: ApiClient, name: string): Promise<CreatedHost> {
  return api.request<CreatedHost>('POST', '/api/hosts', { body: { name } });
}

export function revokeHost(api: ApiClient, id: string): Promise<void> {
  return api.request<void>('DELETE', `/api/hosts/${encodeURIComponent(id)}`);
}
